import { observable } from "mobx";
import { IVehicle } from "./types";
import { EntityValidationRules } from "../services/validationService";
import FuelType from "entities/fuelType";

export default class Vehicle implements IVehicle {
  @observable licensePlate?: string;

  @observable _licensePlateConfirmation?: string;

  @observable countryId?: string;

  @observable _countryIdConfirmation?: string;

  @observable fuelType?: FuelType;

  @observable authCode?: string;

  @observable emailAddress?: string;

  @observable _alternativeDrive = false;

  @observable canBeChangedBeforeValidity?: boolean;

  @observable canBeChangedDuringValidity?: boolean;
}

export const CountryIdConfirmationValidationRules: EntityValidationRules<Vehicle> = {
  _countryIdConfirmation: {
    equalWith: { property: "countryId" as const },
  },
};
